import { Box, HStack } from "@zenchef/styled-system/jsx";
import { Text } from "../typography/Text";
import Tag, { TagProps } from "../Tag/Tag";

export interface TitleExposedProps {
  /**
   * Label to show in the title
   */
  label: string;
  /**
   * Tag label to show near the title
   */
  tagLabel?: string;
  /**
   * Properties to customize the tag
   */
  tag?: TagProps;
  /**
   * Description to show below the header title
   */
  description?: string;
}

export interface TitleInternalProps extends TitleExposedProps {
  className?: string;
}

export default function Title({
  className,
  label,
  tagLabel,
  description,
  tag,
}: TitleInternalProps) {
  return (
    <Box className={className}>
      <HStack gap="gap.2">
        <Text
          textStyle={{
            base: "title.l",
            xsDown: "title.m",
          }}
        >
          {label}
        </Text>
        {tagLabel ? <Tag {...tag}>{tagLabel}</Tag> : null}
      </HStack>
      {description ? (
        <Text textStyle="paragraph.m.regular">{description}</Text>
      ) : null}
    </Box>
  );
}
